import React, { FC, MouseEventHandler, useState } from 'react';
import { HelpCircle as HelpCircleIcon, Home as HomeIcon, ThumbsUp as ThumbsUpIcon, Clipboard as CopyIcon, Menu as MenuIcon, Heart as HeartIcon } from "react-feather";
import { Link, useSearchParams } from "react-router-dom";
import * as NavigationHelper from "../common/navigationHelper";
import Search from "./search/Search";
import HeaderSearch from "./search/HeaderSearch";

interface HeaderProps {
    isScrolledToTop: boolean;
    homeClicked: any;
}

const Navigation: FC<HeaderProps> = (props) => {
    const [searchParams] = useSearchParams();

    const [menuExpanded, toggleMenu] = useState(false);

    const query = searchParams.get("query");
    const url = window.location.href;

    const goHome = () => {
        props.homeClicked();
        return "/";
    }

    const expandMenu: MouseEventHandler<HTMLAnchorElement> = (event) => {
        event.preventDefault();
        toggleMenu(!menuExpanded)
    }

    const [searchValue, setSearchValue] = useState("");
    
    const copyLink: MouseEventHandler<HTMLAnchorElement> = (event) => {
        event.preventDefault();
        let modifiedURL: string;
        modifiedURL = url.split("%3F")[0] + "%3F";

        navigator.clipboard.writeText(modifiedURL);
        alert("The link to this page has been copied to your clipboard!");

    }
 
    return (
        <div className={`alice-header ${props.isScrolledToTop && window.location.pathname == "/" ? "static-navbar" : "scrolling-navbar"}`}>
            <div role="banner" className="header-uhm" id="alice-header-nav">
                <div className="wrap extra-large">
                    <nav className="nav-uhm alice-icons" role="menu" style={{ overflow: 'visible' }}>
                        <ul className="left-list menu">
                            <li className={ "expandButton" }>
                                <a href="/" onClick={expandMenu} className="expandButtonBorderAdjust menuitem menuItemAdjust ">
                                    <MenuIcon className="icon-button" />
                                    <span className="icon-button-text">Menu</span>
                                </a>
                            </li>
                            <li className={`${menuExpanded ? "expandHome expandCommonCSS innerMenuAdjust" : "hideMiniMenuButton"}`}>
                                <Link onClick={goHome} className={`menuitem  menuItemAdjust`} to="/">
                                    <HomeIcon className="icon-button" />
                                    <span className="icon-button-text">Home</span>
                                </Link>
                            </li>
                            <li className={`${menuExpanded ? "expandHelp expandCommonCSS innerMenuAdjust" : "hideMiniMenuButton"}`}>
                                <Link className={`menuitem menuItemAdjust`} to="/help">
                                    <HelpCircleIcon className="icon-button" />
                                    <span className="icon-button-text">Help</span>
                                </Link>
                            </li>
                            
                        </ul>
                        <ul className="right-list">
                            <li className={`${menuExpanded ? "expandCopy expandCommonCSS innerMenuAdjust" : "hideMiniMenuButton"}`}>
                                <a href="/" onClick={copyLink} className={`menuitem menuItemAdjust`}>
                                    <CopyIcon className="icon-button" />
                                    <span className="icon-button-text">Copy Link</span>
                                </a>
                            </li>
                            <li className={`${menuExpanded ? "expandThumbsUp expandCommonCSS innerMenuAdjust" : "hideMiniMenuButton"}`}>
                                <a href="/favorite" className={`menuitem menuItemAdjust`}>
                                    <HeartIcon className="icon-button" />
                                    <span className="icon-button-text">Favorites</span>
                                </a>
                            </li>
                        </ul>
                        <div></div>
                    </nav>
                </div>
            </div>
        </div>
    );
}

export default Navigation;
